var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('x-input',_vm._g(_vm._b({attrs:{"type":_vm.visible ? 'text' : 'password',"rules":_vm.computedRules,"prependIcon":{ name: 'mdi-lock-outline' },"appendIcon":{
    name: _vm.visible ? 'mdi-eye' : 'mdi-eye-off',
    class: { visible: _vm.visible },
  },"required":""},on:{"click:append":_vm.onClickVisible}},'x-input',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }